/**
 * @generated SignedSource<<7c2091275ae0ef84124ebd950d364c9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberGroupKind = "custom" | "default" | "role" | "test_user" | "%future added value";
export type MemberGroupVisibility = "admin_only" | "everyone" | "%future added value";
export type CreateMemberGroupInput = {
  addLeadUserIds?: ReadonlyArray<string> | null;
  assetId?: string | null;
  color?: string | null;
  description?: string | null;
  kind: MemberGroupKind;
  name: string;
  organizationId: string;
  parentMemberGroupId?: string | null;
  productId?: string | null;
  userIds?: ReadonlyArray<string> | null;
  visibility?: MemberGroupVisibility | null;
};
export type CreateMemberGroupFormMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateMemberGroupInput;
};
export type CreateMemberGroupFormMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AdminGroupsListRowFragment">;
    } | null;
  };
};
export type CreateMemberGroupFormMutation = {
  response: CreateMemberGroupFormMutation$data;
  variables: CreateMemberGroupFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystem",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateMemberGroupFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v2/*: any*/),
        "concreteType": "CreateMemberGroupResponse",
        "kind": "LinkedField",
        "name": "createMemberGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberGroup",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AdminGroupsListRowFragment"
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateMemberGroupFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v2/*: any*/),
        "concreteType": "CreateMemberGroupResponse",
        "kind": "LinkedField",
        "name": "createMemberGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberGroup",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "organizationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatarURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupMembershipNodeConnection",
                "kind": "LinkedField",
                "name": "unassignedMembers",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "childrenGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentMemberGroupId",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v14/*: any*/),
                          (v8/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroup",
                            "kind": "LinkedField",
                            "name": "parentMemberGroup",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroupMembershipNodeConnection",
                            "kind": "LinkedField",
                            "name": "memberGroupMemberships",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          },
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": [],
                "handle": "connection",
                "key": "AdminGroupsListRow__childrenGroups",
                "kind": "LinkedHandle",
                "name": "childrenGroups"
              },
              {
                "alias": "sampleMemberships",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 3
                  }
                ],
                "concreteType": "MemberGroupMembershipNodeConnection",
                "kind": "LinkedField",
                "name": "memberGroupMemberships",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupMembershipNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroupMembership",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fullName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avatar",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isTest",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "memberGroupMemberships(first:3)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "MemberGroupNodeEdge"
              }
            ]
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "261cd236ee11f2ab7d3e89b2a8a6dc21",
    "id": null,
    "metadata": {},
    "name": "CreateMemberGroupFormMutation",
    "operationKind": "mutation",
    "text": "mutation CreateMemberGroupFormMutation(\n  $input: CreateMemberGroupInput!\n) {\n  response: createMemberGroup(input: $input) {\n    node {\n      id\n      ...AdminGroupsListRowFragment\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AdminGroupsListRowFragment on MemberGroup {\n  id\n  name\n  color\n  kind\n  isSystem\n  createdAt\n  productId\n  organizationId\n  description\n  avatarURL\n  unassignedMembers {\n    totalCount\n  }\n  ...UnassignedMemberRowFragment\n  ...DeleteMemberGroupButtonFragment\n  ...CreateMemberGroupButtonFragment\n  ...EditMemberGroupButtonFragment\n  ...MemberGroupTagFragment\n  ...MemberGroupVisibilityChipFragment\n  ...MemberGroupKindChipFragment\n  childrenGroups {\n    edges {\n      node {\n        id\n        ...GroupsListChildGroupRowFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  sampleMemberships: memberGroupMemberships(first: 3) {\n    totalCount\n    edges {\n      node {\n        id\n        user {\n          id\n          firstName\n          lastName\n          ...ProfileAvatarFragment\n          ...ProfileListModalListItemFragment\n        }\n      }\n    }\n  }\n}\n\nfragment CreateMemberGroupButtonFragment on MemberGroup {\n  ...CreateMemberGroupModalFragment\n}\n\nfragment CreateMemberGroupModalFragment on MemberGroup {\n  id\n}\n\nfragment DeleteMemberGroupButtonFragment on MemberGroup {\n  id\n  name\n  productId\n}\n\nfragment DeleteSubGroupButtonFragment on MemberGroup {\n  id\n  name\n  productId\n  parentMemberGroupId\n}\n\nfragment EditMemberGroupButtonFragment on MemberGroup {\n  id\n}\n\nfragment GroupsListChildGroupRowFragment on MemberGroup {\n  id\n  kind\n  createdAt\n  ...DeleteSubGroupButtonFragment\n  ...EditMemberGroupButtonFragment\n  ...MemberGroupTagFragment\n  ...MemberGroupVisibilityChipFragment\n  ...MemberGroupKindChipFragment\n  product {\n    name\n    id\n  }\n  parentMemberGroup {\n    name\n    id\n  }\n  memberGroupMemberships {\n    totalCount\n  }\n}\n\nfragment MemberGroupKindChipFragment on MemberGroup {\n  isSystem\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment MemberGroupVisibilityChipFragment on MemberGroup {\n  visibility\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileListModalListItemFragment on User {\n  id\n  firstName\n  lastName\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment UnassignedCreateMemberGroupButtonFragment on MemberGroup {\n  id\n}\n\nfragment UnassignedMemberRowFragment on MemberGroup {\n  __typename\n  id\n  productId\n  ...UnassignedCreateMemberGroupButtonFragment\n  unassignedMembers {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d751e6ed10448d37b930630f19f092c";

export default node;
